var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModel } from './BaseModel';
export var CustomerConsentFormType;
(function (CustomerConsentFormType) {
    CustomerConsentFormType["TEMPLATE"] = "template";
    CustomerConsentFormType["CONSENT"] = "consent";
})(CustomerConsentFormType || (CustomerConsentFormType = {}));
var CustomerConsentFormModel = /** @class */ (function (_super) {
    __extends(CustomerConsentFormModel, _super);
    function CustomerConsentFormModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CustomerConsentFormModel.prototype, "isSigned", {
        get: function () {
            return this.signature && !!this.signedAt;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CustomerConsentFormModel.prototype, "signatureStatus", {
        get: function () {
            var now = new Date();
            if (this.isSigned) {
                return '서명완료';
            }
            if (this.expiredAt && now > this.expiredAt) {
                return '서명안함(만료)';
            }
            return '서명전';
        },
        enumerable: false,
        configurable: true
    });
    return CustomerConsentFormModel;
}(BaseModel));
export { CustomerConsentFormModel };
